/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExchangeH = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor" fillRule="evenodd">
      <path d="M22 17H5.768l3.353 3.354-1.414 1.414L2 16.06l1-1V15h.062l4.645-4.647 1.414 1.415-3.231 3.231L22 15z" />
      <path d="m22.011 8.06-5.707 5.707-1.414-1.414L18.244 9H2V7h16.124L14.89 3.766l1.414-1.414L20.951 7H21v.048z" />
    </g>
  </Icon>
);
export { SvgExchangeH as ExchangeH };
